import React, { Component, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import ScreeningSignIn from "./ScreeningSignIn";
import ScreeningPage from "./ScreeningPage";
import service from "../../services";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../redux/bindActionCretor";
import { connect } from "react-redux";
import ErrorPopUp from "../../component/errorPopUp";
import Cookies from "universal-cookie";

let sub;
const cookies = new Cookies();

class Moderator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scannerDetails: {},
      sc: false,
      errorMsgShow:''
    };
    this.apiserve = new service();
  }

  componentDidMount() {
    this.apiserve.connect((flag) => {
      if (flag) {
        this.setState({ sc: flag });
        const { match } = this.props;
        const search = this.props.location.search;
        if (search) {
          const res = this.apiserve.decrypt(search.replace("?data=", ""))
          res.then((res) => {
            this.setState({ scannerDetails: res }, () => {
              const sd = this.props.scannerLoginData
              if (res.film && res.film.length !== 0 && res.filmType && res.filmType.length !== 0) {
                if (sd && sd.filmId && sd.channelId && sd.filmType) {
                  // cookies.remove(this.props.scannerLoginData.filmId, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                  // this.goToModerator(this.props.scannerLoginData)
                  // this.props.ScannerLoginData({});
                  // this.props.history.push(`signin${search}`);
                }
              } else this.goToMain();
            });
          });
        } else this.goToMain();

        this.responseHandler();
      }
    });
  }

  componentWillUnmount = () => {
    if (sub) sub.unsubscribe();
  };


  responseHandler = () => {

    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "admin|screenerSignup":
          if (!response.error) {
            this.setState({ loaderFlag: false });
            this.goToModerator(response.data)
          }else{
            this.setState({errorMsgShow:response.data.error})
          }
          break;
        default:
          break;
      }
    });
  };

  goToModerator = (data) => {
    const { match } = this.props;
    this.props.ScannerLoginData(data);
    this.props.history.push(`${match.path}/screening${this.props.location.search}`);
  }

  goToMain = () => {
    // ToDo: redirect to main login page or dashboard page
  };

  errorModel = () => {
    this.setState({
      errorMsgShow: false
    });
  };

  render() {
    const { match } = this.props;
    const { sc ,errorMsgShow } = this.state;
    return (
      <React.Fragment>
        {sc && 
        <Switch>
          <Route exact path={`${match.path}/signin`} component={ScreeningSignIn} />
          <Route exact path={`${match.path}/screening`} component={ScreeningPage} />
        </Switch>}

        {errorMsgShow && (
          <ErrorPopUp errorMsg={this.state.errorMsgShow} errorMsgPopup={this.errorModel} />
        )}
      </React.Fragment>


    );
  }
}


const mapStateToProps = state => ({
  scannerLoginData: state.scannerLoginData
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(Moderator);